import * as go from 'gojs';

import { addToken, removeToken } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/addAndRemoveToken';
import { updateTokens } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/updateTokens';
import { getNewTokensShowingPoints } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/getNewTokensShowingPoints';
import { getLinksWithLengths } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/getLinksWithLengths';

let newTokensShowingPoints = [];
let linksWithLength = [];
let request;

export const stopLifecycleAnimation = (diagram: go.Diagram) => {
    window.cancelAnimationFrame(request);
    newTokensShowingPoints = [];
    linksWithLength = [];
    diagram.parts.each((part) => {
        if (part.category === 'token') {
            removeToken(diagram, part);
        }
    });
};

const loop = (diagram, color) => {
    updateTokens(newTokensShowingPoints, linksWithLength, diagram, color);
    request = window.requestAnimationFrame(() => loop(diagram, color));
};

export const animateLifecycleVariant = (
    linksArray: go.ObjectData[],
    diagram: go.Diagram,
    color: string
) => {

    addToken(diagram, { color, leader: true });
    request = window.requestAnimationFrame(() => {
        linksWithLength = getLinksWithLengths(diagram, linksArray);
        newTokensShowingPoints = getNewTokensShowingPoints(linksWithLength);

        loop(diagram, color);
    });
};
